import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _delay from 'lodash/delay';
import PropTypes from 'prop-types';
// Models
import mSimcard from 'models/simcard';
// Custom
import {
  openDialog, getApnsList, getSimcardGroupsList, getSimcardsList, synchronizeSimcards,
  addSimcardGroup, addSimcardGroupApn, deleteSimcardGroupApn,
} from 'actions';
import { fullListShape } from 'constants/PropTypesShapes';
import { navigateToShow } from 'simcards/navigation';
import { GroupsTextButton } from 'components/buttons/TextButtons';
import { SyncContainedButton } from 'components/buttons/ContainedButtons';
import withLoading from 'hocs/WithLoading';
import withConfirmDialog from 'hocs/WithConfirmDialog';
import withStateReinit from 'hocs/WithStateReinit';
import withTitle from 'hocs/WithTitle';
import MainListTemplate from 'components/templates/MainListTemplate';
import SimcardFilters from 'simcards/assets/main/SimcardFilters';
import SimcardRow from 'simcards/assets/main/SimcardRow';

class SimcardsList extends React.Component {
  constructor(props) {
    super(props);

    this.handleSynchronize = this.handleSynchronize.bind(this);
    this.handleDisplayGroups = this.handleDisplayGroups.bind(this);
    this.handleRowDbleClick = this.handleRowDbleClick.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);
  }

  componentDidMount() {
    const { handleGetSimcardGroupsList, handleGetApnsList } = this.props;
    handleGetApnsList();
    handleGetSimcardGroupsList();
  }

  componentDidUpdate(prevProps) {
    const {
      simcardGroupAdded, simcardGroupApnAdded, simcardGroupApnDeleted, handleGetSimcardGroupsList,
    } = this.props;
    if (
      (!prevProps.simcardGroupAdded && simcardGroupAdded)
      || (!prevProps.simcardGroupApnAdded && simcardGroupApnAdded)
      || (!prevProps.simcardGroupApnDeleted && simcardGroupApnDeleted)
    ) {
      handleGetSimcardGroupsList();
    }
  }

  // Handlers
  handleSynchronize() {
    const { handleDisplayConfirm, handleSynchronizeSimcards } = this.props;
    handleDisplayConfirm(
      { id: 'confirm.synchronizeSimcards' },
      () => handleSynchronizeSimcards(),
      {
        confirmLabel: 'synchronize',
      },
    );
  }

  handleDisplayGroups(e) {
    e.preventDefault();
    const {
      handleOpenDialog, handleAddSimcardGroup, handleAddSimcardGroupApn, handleDeleteSimcardGroupApn,
    } = this.props;
    handleOpenDialog({
      title: {
        id: 'title.simcardsGroups',
      },
      actions: [
        { type: 'close' },
      ],
      component: {
        type: 'SIMCARD_GROUPS_MANAGER',
        props: {
          onAddSimcardGroup: handleAddSimcardGroup,
          onAddSimcardGroupApn: handleAddSimcardGroupApn,
          onDeleteSimcardGroupApn: handleDeleteSimcardGroupApn,
        },
      },
    });
  }

  handleRowDbleClick(simcard) {
    const { handleStartLoading } = this.props;
    if (simcard) {
      // Display loader and display simcard
      handleStartLoading();
      _delay(() => navigateToShow(simcard.id), 500);
    }
  }

  // Private
  doGetRowComp(props) {
    return (
      <SimcardRow {...props} />
    );
  }

  render() {
    const { simcards, handleGetSimcardsList } = this.props;

    return (
      <MainListTemplate
        title={
          <LocalizedMessage id="title.simcardsList" />
        }
        icon={mSimcard.icon}
        displayRefresh
        actionButtons={[
          <SyncContainedButton key="bSync" onClick={this.handleSynchronize} />,
          <GroupsTextButton key="bGroups" primary onClick={this.handleDisplayGroups} />,
        ]}
        name={mSimcard.name}
        listFeatures={mSimcard.listFeatures}
        withActions
        elementsData={{
          loading: simcards.loading,
          elements: simcards.elements,
          handleGetList: handleGetSimcardsList,
        }}
        onRowDbleClick={this.handleRowDbleClick}
        filtersComp={
          <SimcardFilters />
        }
        rowComp={this.doGetRowComp}
      />
    );
  }
}

SimcardsList.propTypes = {
  simcards: fullListShape.isRequired,
  simcardGroupAdded: PropTypes.bool.isRequired,
  simcardGroupApnAdded: PropTypes.bool.isRequired,
  simcardGroupApnDeleted: PropTypes.bool.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
  handleDisplayConfirm: PropTypes.func.isRequired,
  handleGetApnsList: PropTypes.func.isRequired,
  handleGetSimcardGroupsList: PropTypes.func.isRequired,
  handleGetSimcardsList: PropTypes.func.isRequired,
  handleSynchronizeSimcards: PropTypes.func.isRequired,
  handleAddSimcardGroup: PropTypes.func.isRequired,
  handleAddSimcardGroupApn: PropTypes.func.isRequired,
  handleDeleteSimcardGroupApn: PropTypes.func.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  simcards: state.simcard.list,
  simcardGroupAdded: state.simcardGroup.add.added,
  simcardGroupApnAdded: state.simcardGroup.addApn.added,
  simcardGroupApnDeleted: state.simcardGroup.deleteApn.deleted,
});

const mapDispatchToProps = (dispatch) => ({
  handleOpenDialog: (props) => {
    dispatch(openDialog(props));
  },
  handleGetApnsList: (pagination, sort, filters) => {
    dispatch(getApnsList(pagination, sort, filters));
  },
  handleGetSimcardGroupsList: (pagination, sort, filters) => {
    dispatch(getSimcardGroupsList(pagination, sort, filters));
  },
  handleGetSimcardsList: (pagination, sort, filters) => {
    dispatch(getSimcardsList(pagination, sort, filters));
  },
  handleSynchronizeSimcards: () => {
    dispatch(synchronizeSimcards());
  },
  handleAddSimcardGroup: (data) => {
    dispatch(addSimcardGroup(data));
  },
  handleAddSimcardGroupApn: (id, data) => {
    dispatch(addSimcardGroupApn(id, data));
  },
  handleDeleteSimcardGroupApn: (id, data) => {
    dispatch(deleteSimcardGroupApn(id, data));
  },
});

module.exports = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withLoading,
  withConfirmDialog,
  withStateReinit(['synchronizeSimcards']),
  withTitle('pageTitle.simcards'),
)(SimcardsList);



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/routes/list/components/SimcardsList.js